import { getPageModelIsLoading, getPageModelIsLoaded } from 'domains/pageModel/store/selectors';
import { createLoadData } from 'utils/create-load-data';
import { fetchModel } from 'domains/pageModel/store/actions';

export const loadData = createLoadData(({ subscribe, dispatch, resolve }) => {
  subscribe(state => {
    const isPageModelLoaded = getPageModelIsLoaded(state);
    const IsPageModelLoading = getPageModelIsLoading(state);
    if (isPageModelLoaded && !IsPageModelLoading) {
      resolve();
    }
    if (!isPageModelLoaded && !IsPageModelLoading) {
      dispatch(fetchModel.request());
    }
  });
});
